import { ClassificationCode } from "@/types/code.types";

import { AUTHORITY_TYPE } from "../constants/authorityType.constants";
import { ALLOWED_EDITOR_ROLES_AND_CLASSIFICATION_EDIT_ARTICLE } from "../constants/editorRolesAndClassification.constants";

import type { AuthorityType, EditorRoleCode } from "../types/roles.types";

interface Args {
  editorRoles: EditorRoleCode[];
  authorityType: AuthorityType;
  classification: ClassificationCode;
}

export class EditArticleRoleChecker {
  private editorRoles: EditorRoleCode[];

  private authorityType: AuthorityType;

  private classification: ClassificationCode;

  constructor({ editorRoles, authorityType, classification }: Args) {
    this.editorRoles = editorRoles;
    this.authorityType = authorityType;
    this.classification = classification;
  }

  private get hasValidRoles(): boolean {
    return this.editorRoles.some((role) =>
      ALLOWED_EDITOR_ROLES_AND_CLASSIFICATION_EDIT_ARTICLE[role]?.includes(
        this.classification,
      ),
    );
  }

  private get isSuperAdmin(): boolean {
    return this.authorityType === AUTHORITY_TYPE.superAdmin;
  }

  public get canAccess(): boolean {
    return this.isSuperAdmin || this.hasValidRoles;
  }
}
